import React from 'react';
import PropTypes from 'prop-types';

import NoteIcon from '../../../common/icons/files/NoteIcon';

export default function BudgetTrackingEmptyState({ text }) {
  return (
    <div className="budget-tracking-empty-state">
      <div className="budget-tracking-empty-state-icon-wrapper">
        <div className="budget-tracking-empty-state-grid" /> {/* Grid pattern with radial fade */}
        <div className="budget-tracking-empty-state-icon">
          <NoteIcon />
        </div>
      </div>
      <div className="budget-tracking-empty-state-text">
        {text}
      </div>
    </div>
  );
}

BudgetTrackingEmptyState.propTypes = {
  text: PropTypes.string,
};

BudgetTrackingEmptyState.defaultProps = {
  text: 'No data available',
};
